import { useState } from "react";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { LINKS } from "@/lib/site";
import { BUILD_REFUND_PERCENT } from "@/lib/commercial-terms";
import "./Pricing.css";

const engagements = [
  { name: "Pod", scope: "One market", description: "A managed sales team to win customers in one market.", price: "$27,000" },
  { name: "Team", scope: "More sales capacity", description: "More salespeople to handle more buyers and close more deals.", price: "$33,000" },
  { name: "Enterprise", scope: "Multiple markets", description: "Sales teams across markets, products or regions. Managed for you.", price: "$45,000" },
];

export const Pricing = () => {
  const [activePlan, setActivePlan] = useState(0);
  const plan = engagements[activePlan];

  return (
    <section id="pricing" className="pricing-section" data-testid="pricing-section">
      <div className="pricing-shell">
        <header className="pricing-intro">
          <p className="pricing-eyebrow">Pricing</p>
          <h2 className="font-display">Build once. Scale after proof.</h2>
        </header>

        <div className="pricing-box">
          <div className="pricing-selector" role="group" aria-label="Choose a package">
            {engagements.map((option, index) => (
              <button key={option.name} id={`pricing-choice-${index}`} type="button" aria-pressed={activePlan === index} aria-controls="pricing-plan" onClick={() => setActivePlan(index)}>
                <span className="font-display">{option.name}</span>
                <span className="pricing-selector-scope">{option.scope}</span>
              </button>
            ))}
          </div>

          <article id="pricing-plan" className="pricing-plan" aria-labelledby={`pricing-choice-${activePlan}`}>
            <div className="pricing-offer" aria-live="polite" aria-atomic="true">
              <h3 className="font-display">The {plan.name}</h3>
              <p className="pricing-description">{plan.description}</p>
            </div>

            <div className="pricing-payment-line" aria-label="How you pay">
              <div className="pricing-payment-step">
                <p>Build once</p>
                <strong className="font-display" data-testid="build-price">{plan.price}</strong>
                <span>One-off payment</span>
              </div>
              <ArrowRight className="pricing-payment-arrow" aria-hidden="true" />
              <div className="pricing-payment-step pricing-payment-proof">
                <p>Until the target</p>
                <strong className="font-display">$0<span>/month</span></strong>
                <span>Commission only until $80k is collected</span>
              </div>
              <ArrowRight className="pricing-payment-arrow" aria-hidden="true" />
              <div className="pricing-payment-step">
                <p>If you scale</p>
                <strong className="font-display"><b data-testid="scale-price">{plan.price}</b><span>/month</span></strong>
                <span>Plus commission</span>
              </div>
            </div>

            <div className="pricing-included" data-testid="pricing-included">
              <p><strong>Built and managed for you:</strong> salespeople, management, content, outreach, AI Agents, CRM, dialer, buyer data &amp; all necessary software.</p>
            </div>

            <footer className="pricing-footer">
              <div className="pricing-refund" data-testid="build-refund">
                <strong className="font-display">{BUILD_REFUND_PERCENT}%</strong>
                <p><strong>of your build payment back</strong><span>if we miss the agreed target.</span></p>
              </div>
              <a href={LINKS.cal} target="_blank" rel="noopener noreferrer" className="pricing-book" data-testid="pricing-book">Book a meeting <ArrowUpRight size={20} aria-hidden="true" /></a>
            </footer>
          </article>
        </div>
      </div>
    </section>
  );
};
